export const GET_BULK_PUSH_NOTIFICATION_START =
  'GET_BULK_PUSH_NOTIFICATION_START';
export const GET_BULK_PUSH_NOTIFICATION_SUCCESS =
  'GET_BULK_PUSH_NOTIFICATION_SUCCESS';
export const GET_BULK_PUSH_NOTIFICATION_ERROR =
  'GET_BULK_PUSH_NOTIFICATION_ERROR';
